import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_9',
  type: NAVBAR,
  name: 'Navbar 9',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_9.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: 'white',editable: true},
      color: {type: 'css', value: '#000000',editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemUnderline: {type: 'custom', value: '#000000', editable: true},
      navItemHoverUnderline: {type: 'custom', value: '#d7913c', editable: true},
      navItemActiveUnderline: {type: 'custom', value: '#f1eb50', editable: true},
      navItemPadding: {type: 'custom', value: '0.5rem 2rem', editable: true},
      fontWeight: {type: 'css', value: 'Bold'},
    },
    contents: []
  }
}
